__turbopack_context__.v({
  "growWrap": "Textarea-module__pxuQ0q__growWrap",
  "input": "Textarea-module__pxuQ0q__input",
  "input--error": "Textarea-module__pxuQ0q__input--error",
});
